export const name = "LOGICAL_OR";
export const summary = `Gets the logical OR of all non-\`NULL\` expressions.`;
export const reference = `
## LOGICAL_OR

Gets the logical OR of all non-\`NULL\` expressions.

\`\`\`
LOGICAL_OR(
  expression
)
\`\`\`

### Description

Returns the logical OR of all non-\`NULL\` expressions. Returns \`NULL\` if there are zero input rows or \`expression\` evaluates to \`NULL\` for all rows.

To learn more about the optional aggregate clauses that you can pass into this function, see Aggregate function calls.

This function can be used with the \`AGGREGATION_THRESHOLD\` clause.


### Supported Argument Types

\`BOOL\`


### Return Data Types

\`BOOL\`


### Examples

\`LOGICAL_OR\` returns \`TRUE\` because at least one of the values in the array is less than 3.



\`\`\`
SELECT LOGICAL_OR(x < 3) AS logical_or FROM UNNEST([1, 2, 4]) AS x;

/*------------*
 | logical_or |
 +------------+
 | TRUE |
 *------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
